module.exports = __webpack_public_path__ + "static/img/oblique.c7ca306c.svg";